import { Descriptions } from 'antd';
import styled from 'styled-components';

const DescriptionsStyled = styled(Descriptions)`
  span[class*=label] {
    font-weight: bold;
  }
`;

DescriptionsStyled.Item = Descriptions.Item;
export default DescriptionsStyled;
